import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import CloneOffer from './submodules/clone';
import CreateOffer from './submodules/create';
import OfferList from './submodules/list';
import EditOffer from './submodules/edit';

const TdsDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getTDSActiveOffers]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={OfferList}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createTDSOffers]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/clone`}
				component={CloneOffer}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createTDSOffers]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateOffer}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updateTDSOffers]}
				path={`${path}/edit`}
				configPageName={PAGE_NAMES.dashboard}
				component={EditOffer}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default TdsDashboard;
